/*
 * @Date: 2023-02-14 09:56:13
 * @LastEditTime: 2026-01-31 10:00:00
 * @Description: 用户相关API - 同步小程序端功能
 */
import { request } from "@/request/request";
import { parameterChange } from "@/utils/utils";

export default {
  // 获取用户信息
  getUserInfo(data) {
    return request({
      url: "/user_info/getUserInfo?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 更新用户信息
  updateUserInfo(data) {
    return request({
      url: "/user_info/updateUserInfo",
      method: "post",
      data,
    });
  },
  // 更新用户手机号
  updatePhone(data) {
    return request({
      url: "/user_info/updatePhone",
      method: "post",
      data,
    });
  },
  // 修改密码
  updatePassword(data) {
    return request({
      url: "/user_info/updatePassword",
      method: "post",
      data,
    });
  },
  // 注销用户
  logoffUser(data) {
    return request({
      url: "/user_info/logoffUser",
      method: "post",
      data,
    });
  },
};
